'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled, { keyframes, css } from 'styled-components';
import { ANIMATION_DURATION } from './constants.js';
import { colors } from '../Utils/constants.js';

var barAnimX = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(0%);\n  }\n"])));
var barAnimY = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n"], ["\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  }\n"])));
var BarChartWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    position: relative;\n"], ["\n    width: 100%;\n    position: relative;\n"])));
var BarRect = styled.rect(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isHaveAnim = _a.isHaveAnim;
    if (!isHaveAnim) {
        return '`';
    }
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            transition: height ", " ease-in-out, fill ", " ease-in-out, opacity ", " ease-in-out;\n            opacity: ", ";\n            animation: ", " ", " ease-in-out;\n        "], ["\n            transition: height ", " ease-in-out, fill ", " ease-in-out, opacity ", " ease-in-out;\n            opacity: ", ";\n            animation: ", " ", " ease-in-out;\n        "])), ANIMATION_DURATION, ANIMATION_DURATION, ANIMATION_DURATION, function (_a) {
        var opacity = _a.opacity;
        return opacity;
    }, function (_a) {
        var isHorizontal = _a.isHorizontal;
        return (isHorizontal ? barAnimX : barAnimY);
    }, ANIMATION_DURATION);
});
var BarText = styled.text(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    transition: height ", " ease-in-out;\n    animation: ", " ", " ease-in-out;\n"], ["\n    transition: height ", " ease-in-out;\n    animation: ", " ", " ease-in-out;\n"])), ANIMATION_DURATION, function (_a) {
    var isHorizontal = _a.isHorizontal;
    return (isHorizontal ? barAnimX : barAnimY);
}, ANIMATION_DURATION);
var AxisText = styled.text(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    fill: #888;\n    font-size: 12px;\n"], ["\n    fill: #888;\n    font-size: 12px;\n"])));
var TooltipDot = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    margin-right: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n"], ["\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    margin-right: 8px;\n    border-radius: 50%;\n    background-color: ", ";\n"])), function (_a) {
    var bgColor = _a.bgColor;
    return bgColor;
});
var TooltipText = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 22px;\n    margin-left: ", "px;\n"], ["\n    color: ", ";\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 22px;\n    margin-left: ", "px;\n"])), function (_a) {
    var isYou = _a.isYou, highlightColor = _a.highlightColor;
    return (isYou ? highlightColor : colors.darkBlueColor);
}, function (_a) {
    var isMarginLeft = _a.isMarginLeft;
    return (isMarginLeft ? 4 : 0);
});
styled.g(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isHorizontal = _a.isHorizontal;
    if (!isHorizontal) {
        return '';
    }
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n            transform: rotate(-90deg);\n            translate: 0 ", "px;\n        "], ["\n            transform: rotate(-90deg);\n            translate: 0 ", "px;\n        "])), function (_a) {
        var leftPadding = _a.leftPadding;
        return leftPadding;
    });
});
styled.g(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isHorizontal = _a.isHorizontal;
    if (!isHorizontal) {
        return '';
    }
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n            transform: rotate(90deg);\n            translate: ", "px 0;\n        "], ["\n            transform: rotate(90deg);\n            translate: ", "px 0;\n        "])), function (_a) {
        var leftPadding = _a.leftPadding;
        return leftPadding;
    });
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;

export { AxisText, BarChartWrapper, BarRect, BarText, TooltipDot, TooltipText };
//# sourceMappingURL=BarChart.css.js.map
